<template>
  <kst-section items-mode>
    <kst-table view-mode :data="items">
      <b-table-column
        v-slot="{ column, row }"
        field="DispatchID"
        :label="InvItemCatalog.Name.Label"
      >
        <kst-value :field="column.field" :data="row" :catalog="InvItemCatalog"/>
      </b-table-column>

      <b-table-column cell-class="ks-col-nopad" header-class="p-0" width="1">
        <template #header>
          <kst-header-blank />
        </template>
        <template #default="{ row }">
          <kst-tooltip info-mode>
            <template #content>
              <kst-list info-mode :items="Model.RelatedList.getItemInfo(row)"/>
            </template>
            <kst-icon info-mode/>
          </kst-tooltip>
        </template>
      </b-table-column>

      <b-table-column
        v-slot="{ column, row }"
        cell-class="ks-col-packaging"
        field="Packaging"
        :label="InvItemCatalog.Packaging.Label"
      >
        <kst-value :field="column.field" :data="row" :catalog="InvItemCatalog"/>
      </b-table-column>

      <b-table-column numeric
        v-slot="{ column, row }"
        cell-class="ks-col-qty"
        field="RequestedQuantity"
        :label="InvItemCatalog.RequestedQuantity.Label"
      >
        <kst-value :field="column.field" :data="row" :catalog="InvItemCatalog"/>
      </b-table-column>

      <b-table-column numeric
        v-slot="{ column, row }"
        cell-class="ks-col-price"
        field="SellPrice"
        :label="InvItemCatalog.SellPrice.Label"
      >
        <kst-value :field="column.field" :data="row" :catalog="InvItemCatalog"/>
      </b-table-column>

      <template v-if="specialPriceCount > 0">
        <b-table-column numeric
          v-slot="{ column, row }"
          cell-class="ks-col-specialpricename"
          field="SpecialPriceID"
          :label="InvItemCatalog.SpecialPriceID.Label"
        >
          <kst-value :field="column.field" :data="row" :catalog="InvItemCatalog"/>
        </b-table-column>
      </template>

      <b-table-column numeric
        v-slot="{ column, row }"
        cell-class="ks-col-subtotal"
        field="Price"
        :label="InvItemCatalog.Price.Label"
      >
        <kst-value :field="column.field" :data="row" :catalog="InvItemCatalog"/>
      </b-table-column>
    </kst-table>
  </kst-section>
</template>

<script>
import InvItemCatalog from "../InvItemCatalog.js";
import Model from "../InvModel.js";

export default {
  props: {
    items: Array,
    specialPriceCount: Number
  },
  data: () => ({
    InvItemCatalog: InvItemCatalog,
    Model: Model
  })
}
</script>